import Header, { HeaderProps } from "./../Header";
import AdminAvatarMenu from "./AdminAvatarMenu";

export interface AdminHeaderProps extends HeaderProps {}

export default function AdminHeader({ ...props }: AdminHeaderProps) {
  return <Header right={<AdminAvatarMenu />} {...props} />;
}

